/**
 * Peanuts Context
 *
 * @author Peter Oosterwijk
 * @version 1.0.0
 */

/*jslint evil: true */

var Context = function (options) {
    var self = this;

    self.heartbeat = null;

    this.settings = $.extend({

        // General options
        debug: true,
        autoload: true,
        autoMessages: true,
        defaultHashLength: 8,
        errorReporting: true,
        hbInterval: 60000,

        // Callback functions
        onAutoMessage: function (type, title, message, delay) { console.log(message); },
        onSessionExpired: function () { console.log("SESSION EXPIRED"); },
        onSoftwareUpdated: function () { },
        onErrorReport: function (e) { console.log(e); }

    }, options);

    this.call = function(options) {

        try {
            var post = $.extend({
                url: window.location.href,
                htmlResponse: false,
                type: 'POST',
                method: null,
                params:{},
                onSuccess: null,
                onError: null
            }, options);

            if ( post.method !== null ) {
                var packet = {
                    method: post.method ,
                    params: ( post.params !== null &&   typeof post.params === "object" ) ? post.params : {}
                };

                $.ajax({
                    type: post.type,
                    url: post.url,
                    data: packet,
                    success: function (response) {

                        try {

                            if ( post.htmlResponse === false ) {
                                response = ( typeof response !== "object" && self.isJSON(response) ) ? JSON.parse(response) : response;

                                if ( typeof response === "object") {
                                    var status = ( response.status !== null && isNaN(status) ) ? response.status : 500;
                                    var result = ( response.result !== null ) ? response.result : null;
                                    var message = ( response.msg !== null ) ? response.msg : null;

                                    switch ( status ) {

                                        case 200:

                                            if ( typeof post.onSuccess === "function" ) {
                                                post.onSuccess.apply(this, [result, message]);
                                            }
                                            break;

                                        case 401:

                                            if ( typeof self.settings.onSessionExpired === "function" ) {
                                                self.settings.onSessionExpired.apply(this);
                                            }
                                            break;

                                        default:
                                            if ( typeof message === "object" ) {

                                                if ( message.title !== undefined ) {
                                                    var body = ( message.body !== undefined ) ? message.body : null;
                                                    var type = ( message.type !== undefined ) ? message.type : 'notice';
                                                    self.throwMessage(type, message.title, body, 4000);
                                                } else {
                                                    self.throwMessage("notice", language.error.warningTitle, message, 4000);

                                                    if ( self.settings.debug === true ) {
                                                        console.log(response);
                                                    }
                                                }
                                            } else {
                                                self.throwMessage("notice", language.error.warningTitle, message, 4000);

                                                if ( self.settings.debug === true ) {
                                                    console.log(response);
                                                }
                                            }

                                            if ( typeof post.onError === "function" ) {
                                                post.onError.apply(this, [status, message]);
                                            }

                                            break;
                                    }
                                } else {
                                    self.throwMessage(500, language.error.errorTitle, language.error.response);

                                    if ( self.settings.debug === true ) {
                                        console.log(response);
                                    }
                                }
                            } else {

                                if ( typeof post.onSuccess === "function" ) {
                                    post.onSuccess.apply(this, [response]);
                                }
                            }
                        } catch (e) {
                            if ( self.settings.debug ) {
                                console.log(e.stack);
                            }

                            self.throwMessage(500, language.error.script);

                            self.report(e);
                        }
                    },
                    error: function () {

                        if ( self.settings.autoMessages ) {
                            self.throwMessage(500, language.error.errorTitle, language.error.response);
                        }
                    }
                });
            } else if ( post.htmlResponse ) {

                $.ajax({
                    type: post.type,
                    url: post.url,
                    data: {params: ( post.params !== null && typeof post.params === "object" ) ? post.params : {}},

                    success: function (response) {
                        response = ( typeof response !== "object" && self.isJSON(response) ) ? JSON.parse(response) : response;

                        if ( typeof response === "object") {
                            var status = ( response.status !== null && isNaN(status) ) ? response.status : 500;
                            var result = ( response.result !== null ) ? response.result : null;
                            var message = ( response.msg !== null ) ? response.msg : null;

                            switch ( status ) {

                                case 200:

                                    if ( typeof post.onSuccess === "function" ) {
                                        post.onSuccess.apply(this, [result, message]);

                                    }
                                    break;

                                case 401:

                                    if ( typeof self.settings.onSessionExpired === "function" ) {
                                        self.settings.onSessionExpired.apply(this);
                                    }
                                    break;

                                default:
                                    if ( typeof message === "object" ) {

                                        if ( message.title !== undefined ) {
                                            var body = ( message.body !== undefined ) ? message.body : null;
                                            var type = ( message.type !== undefined ) ? message.type : 'notice';
                                            self.throwMessage(type, message.title, body, 4000);
                                        } else {
                                            self.throwMessage("notice", language.error.warningTitle, message, 4000);

                                            if ( self.settings.debug === true ) {
                                                console.log(response);
                                            }
                                        }
                                    } else {
                                        self.throwMessage("notice", language.error.warningTitle, message, 4000);

                                        if ( self.settings.debug === true ) {
                                            console.log(response);
                                        }
                                    }

                                    if ( typeof post.onError === "function" ) {
                                        post.onError.apply(this, [status, message]);
                                    }
                                    break;
                            }


                        } else {

                            if ( typeof post.onSuccess === "function" ) {
                                post.onSuccess.apply(this, [response]);

                                setTimeout(function () {
                                    self.initEvents();
                                }, 500);
                            }
                        }
                    }
                });
            }
        } catch (e) {
            self.report(e);
        }
    };

    this.submit = function(options){

        try {

            if ( options.form !== null){

                if ( $(options.form).length > 0) {
                    var valid = true;

                    if ( $(options.form).data("formValidate") !== null ) {

                        if( $.fn.parsley ) {
                            valid = $(options.form).parsley(app.formModules.parsleyOptions).validate();

                            if ( valid === false ){

                                if ( typeof options.onValidationError === "function"){
                                    options.onValidationError.apply(this);
                                }
                            }
                        }
                    }


                    if ( valid ) {

                        if( typeof $(options.form).attr("data-component-form") !== "undefined" ){
                            app.content.submit(options);
                        }
                        else{

                            var disabled = $(options.form).find(':input:disabled').removeAttr('disabled');
                            var formatted_post = self.createPostData(options.form);


                            if ( typeof options.beforeSubmit === "function"){

                                var processedoptions = options.beforeSubmit.apply(this, [formatted_post]);

                                if ( typeof processedoptions !== "undefined" && processedoptions !== null){
                                    formatted_post = processedoptions;
                                }
                            }

                            options.params = $.extend(formatted_post,options.params);

                            disabled.attr('disabled','disabled');
                            self.call(options);
                        }
                    }
                }
                else{
                    self.throwMessage(500, language.form.noForm);
                }

            }
            else{
                self.throwMessage(500, language.form.noForm);
            }
        } catch (e) {
            console.log(e);
            self.report(e);
        }
    };

    this.createPostData = function(form){

         var formdata = $(form).serializeObject(),
            formatted_post = {},
            match = null;

        $(form).find("[data-plugin=codemirror]").each(function(){
                formdata[$(this).attr("name")] = app.codemirror.getValue($(this).attr("name"));
        });

        $.each(formdata, function(key, value){

            if( key.indexOf("[") > -1 ){
                var keys = key.replace(/[\]]+/g, '').split('[');

                if ( keys.length === 2 ) {

                    if ( typeof keys[1] !== "undefined" ){
                        formatted_post[keys[0]] = ( formatted_post[keys[0]] === undefined ) ? {} : formatted_post[keys[0]];
                        formatted_post[keys[0]][keys[1]] = value;
                    }
                }

                if ( keys.length === 3 ) {
                    formatted_post[keys[0]] = ( formatted_post[keys[0]] === undefined ) ? {} : formatted_post[keys[0]];
                    formatted_post[keys[0]][keys[1]] = ( formatted_post[keys[0]][keys[1]] === undefined ) ? {} : formatted_post[keys[0]][keys[1]];
                    formatted_post[keys[0]][keys[1]][keys[2]] = value;
                }
            }
            else{
                formatted_post[key] = value;
            }

        });

        return formatted_post;

    };

    this.isJSON = function (str) {
        try {
             var json = JSON.parse(str);

             return true;
        } catch(e) {}

        return false;
    };

    this.hash = function (length) {
        try {
            var charset = "abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
            var retVal = "";

            length = ( length === undefined || length === null ) ? self.settings.defaultHashLength : length;

            for (var i = 0, n = charset.length; i < length; ++i) {
                retVal += charset.charAt(Math.floor(Math.random() * n));
            }

            return retVal;
        } catch (e) {
            self.report(e);
        }

        return false;
    };

    this.striptags = function(value, allowed){

        allowed = (((allowed || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join(''); // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)

        var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,
            commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;

        return value.replace(commentsAndPhpTags, '').replace(tags, function($0, $1) {
          return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : '';
        });
    };

    this.getAliasFromURI = function () {
        try {

            if ( window.location.href.match(/\/peanuts/) ) {
                var uri = window.location.pathname;

                return uri.replace(/^\/+|\/+$/gm,'').split('/')[0];
            }
        } catch (e) {
            self.report(e);
        }

        return "";
    };

    this.throwMessage = function (type,title,message,delay) {
        try {

            if ( typeof self.settings.onAutoMessage === "function" ) {
                self.settings.onAutoMessage.apply(this, [type, title, message, delay]);
            }
        } catch (e) {
            self.report(e);
        }
    };

    this.report = function (e) {
        try {

            if ( self.settings.debug === true ) {
                console.log(response);
            }

            if ( self.settings.errorReporting ) {

                if ( typeof self.settings.onErrorReport === "function" ) {
                    self.settings.onErrorReport.apply(this, [e]);
                }
            }
        } catch (e) {}
    };

    this.initEvents = function (elem) {

        try {
            var target = ( typeof elem === "undefined" || elem === null ) ? $("body") : elem;

            $.each(target.find( "*" ), function(key, selector){

                $.each(selector.attributes, function(k, v){

                    if( v.name.indexOf("data-event-") >= 0 ){

                        var keyparts = v.name.split("-");
                        var event = keyparts[keyparts.length - 1];
                        var funcName = $(selector).attr("data-event-" + event);

                        if ( typeof eval(funcName) === "function" ) {

                            if ( !$(selector).prop('class').match(/auto--init_/) ) {
                                var cls = 'auto--init_' + self.hash(8);

                                $(selector).addClass(cls);
                                $(document).on(event, '.'+cls, eval(funcName));
                            }
                        }
                    }
                });
            });
        } catch (e) {
            self.report(e);
        }
    };

    this.loadExtension = function (extension) {
        try {

            if ( typeof window[extension] === "function" ) {
                try {
                    window[extension] = new window[extension](self);

                    if ( typeof window[extension].init === "function" ) {
                            window[extension].init.apply(this);
                            self.initEvents();
                    } else {
                        self.throwMessage(500, language.error.initExtension + ": " + extension);
                    }
                } catch (e) {
                    self.report(e);
                    self.throwMessage(500, language.error.loadExtension + ": " + extension, e.message);
                }
            } else {

                //MH: check if extension already exists
                if ( typeof window[extension] !== "object"){
                    self.throwMessage(500, language.error.noExtension + ": " + extension);
                }
            }
        } catch (e) {
            self.report(e);
        }
    };

    this.setHeartbeat = function () {
        try {

            if ( window.localStorage !== undefined ) {
                var cert = localStorage.getItem('cert');
                /**
                 * Only enable heartbeat when login cert remembered
                 */

                if ( cert !== undefined && cert !== null ) {
                    self.heartbeat = setInterval(function () {
                        self.call({method:'ping'});
                    },self.settings.hbInterval);
                }
            }
        } catch (e) {}
    };

    this.init = function () {

        try {

            if ( self.settings.autoload ) {
                setTimeout(function () {

                    $('[data-extension]').each(function () {

                        if ( $(this).data('extension').match(/,/) ) {
                            var extensions = $(this).data('extension').split(',');

                            for ( var i in extensions) {
                                self.loadExtension(extensions[i]);
                            }
                        } else {
                            self.loadExtension($(this).data('extension'));
                        }
                    });


                    self.initEvents();

                    if ( typeof self.settings.onSoftwareUpdated === "function" ) {
                        self.settings.onSoftwareUpdated.apply(this);
                    }
                }, 300);
            }

        } catch (e) {
            self.report(e);
        }
    };
};

//
// Use internal $.serializeArray to get list of form elements which is
// consistent with $.serialize
//
// From version 2.0.0, $.serializeObject will stop converting [name] values
// to camelCase format. This is *consistent* with other serialize methods:
//
//   - $.serialize
//   - $.serializeArray
//
// If you require camel casing, you can either download version 1.0.4 or map
// them yourself.
//

(function($){
    $.fn.serializeObject = function () {
        "use strict";

        var result = {};
        var extend = function (i, element) {
            var node = result[element.name];

    // If node with same name exists already, need to convert it to an array as it
    // is a multi-value field (i.e., checkboxes)

            if ('undefined' !== typeof node && node !== null) {
                if ($.isArray(node)) {
                    node.push(element.value);
                } else {
                    result[element.name] = [node, element.value];
                }
            } else {
                result[element.name] = element.value;
            }
        };

        $.each(this.serializeArray(), extend);
        return result;
    };
})(jQuery);
